import React from 'react';
import { ActionButton, StyledTable, TableContainer } from './styles';
import { ProdutoClonado } from '~/components/CadastroRapidoProduto/class/SessionStorageService';
import { moneyFormat } from '~/utils/functions';

export const TableProdutoClonado: React.FC<{
  produto: ProdutoClonado;
  onActionClick: () => void;
}> = ({ produto, onActionClick }) => {
  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <tr>
            <th>Produto Origem</th>
            <th>Descrição</th>
            <th>Valor de Venda</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{produto.p_cod_produto_origem}</td>
            <td>{produto.p_des_produto}</td>
            <td>R$ {moneyFormat((produto.p_val_venda ?? 0).toFixed(2))}</td>
            <td>
              <ActionButton onClick={onActionClick}>CANCELAR</ActionButton>
            </td>
          </tr>
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};
